import { Tooltip, Box } from "@mui/material";

// Marker for fields that are really enforced on save (a red dot). Fields that
// only carry the classic "*" are informational and are NOT validated.
export const RequiredDot = ({ title = "Required field" }) => (
    <Tooltip title={title} arrow placement="top">
        <Box
            component="span"
            aria-label={title}
            sx={{
                color: "#d32f2f",
                ml: 0.6,
                fontSize: "1em",
                lineHeight: 1,
                cursor: "help",
                verticalAlign: "middle",
            }}
        >
            ●
        </Box>
    </Tooltip>
);

// mark=false: yalnızca ipucu gösterilir, zorunluluk işareti (* / ●) çizilmez
const RequiredLabelWithTooltip = ({ label, tooltip, dot = false, mark = true }) => (props) => (
    <Tooltip title={tooltip} arrow placement="top">
        <Box
            component="label"
            {...props}
            sx={{
                cursor: "help",
                display: "inline-flex",
                alignItems: "center"
            }}
        >
            {label}
            {!mark ? null : dot ? (
                <Box
                    component="span"
                    aria-label="Required field"
                    sx={{ color: "#d32f2f", ml: 0.6, fontSize: "1em", lineHeight: 1 }}
                >
                    ●
                </Box>
            ) : (
                <Box component="span" sx={{ color: "red", ml: 0.3 }}>
                    *
                </Box>
            )}
        </Box>
    </Tooltip>
);

export default RequiredLabelWithTooltip;
